import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { progressService } from '@/services/progress';

export function useProgressList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: progressService.item.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: progressService.item.remove,
            onSuccess: () => fetchList()
        }),
        disable: crudAction.confirmAndDisable({
            request: progressService.item.disable,
            onSuccess: () => fetchList()
        }),
        enable: crudAction.confirmAndEnable({
            request: progressService.item.enable,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
